import { render, staticRenderFns } from "./Ghibli.vue?vue&type=template&id=66683864&"
import script from "./Ghibli.vue?vue&type=script&lang=js&"
export * from "./Ghibli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports